import React, { useEffect, useState } from 'react'
import "./C2.css";
import Product from "./Product"
import ProductSkeleton from './components/skeleton/ProductSkeleton';
import Carousel from 'react-bootstrap/Carousel'
import axios from "./axios"

function C3() {
    const [foodgrain,setFoodgrain]=useState([])
    const [oil,setOil]=useState([])
    const [masala,setMasala]=useState([])
    const skeleton=[1,2,3,4]

    useEffect(()=>{
        axios({
            url:'/products/category/food grains',
            method:'get'
        }).then(res => setFoodgrain(res.data)).catch(err => console.log("eee",err))
        axios({
            url:'/products/category/oil',
            method:'get'
        }).then(res => setOil(res.data)).catch(err => console.log("eee",err))
        axios({
            url:'/products/category/masala',
            method:'get'
        }).then(res => setMasala(res.data)).catch(err => console.log("eee",err))
    },[])
    return (
        <section className="contaier">
             <Carousel>
                <Carousel.Item interval={4000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/L1-NTP4131-1200x300-25thfeb.jpg"
                    alt="First slide"
                    />
                    {/* <Carousel.Caption>
                    <h3>First slide label</h3>
                    <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={4000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/Organic-Staples-Banner-V2-1200x300.jpg"
                    alt="Third slide"
                    />
                </Carousel.Item>
                {/* <Carousel.Item interval={1000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/NPL2805-NPL2807.jpg"
                    alt="Third slide"
                    />
                </Carousel.Item> */}
                {/* <Carousel.Item interval={1000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/NPL2972.jpg"
                    alt="4 slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={1000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/NPL3027-29-31-11aug20.jpg"
                    alt="5 slide"
                    />
                </Carousel.Item> */}
            </Carousel>
            <section className="container-fluid">
            <h5 className="ml-5 mt-4">Food Grains</h5>           
            <article className="row">
                {
                    foodgrain.length>0?foodgrain.map((d,i)=>
                        <article className="col-md-3" key={i}>
                            <Product
                                id={d._id}
                                title={d.title}
                                price={d.price}
                                rating={d.rating}
                                image={d.image}
                                stock={d.stock}
                                />
                        </article>
                    )
                    :
                    skeleton.map((s,i)=>
                        <article className='col-md-3 col-sm-4' key={i}>
                            <ProductSkeleton />
                        </article>
                   )
                }
            </article>
            <h5 className="ml-5 mt-4">Oils</h5>           
            <article className="row">
                {
                    oil.length>0?oil.map((d,i)=>
                        <article className="col-md-3" key={i}>
                            <Product
                                id={d._id}
                                title={d.title}
                                price={d.price}
                                rating={d.rating}
                                image={d.image}
                                stock={d.stock}
                                />
                        </article>
                    )
                    :
                    skeleton.map((s,i)=>
                        <article className='col-md-3 col-sm-4' key={i}>
                            <ProductSkeleton />
                        </article>
                   )
                }
            </article>
            <h5 className="ml-5 mt-4">Masala</h5> 
            <article className="row">
                {
                    masala.length>0?masala.map((d,i)=>
                        <article className="col-md-3" key={i}>
                            <Product
                                id={d._id}
                                title={d.title}
                                price={d.price}
                                rating={d.rating}
                                image={d.image}
                                stock={d.stock}
                                />
                        </article>
                    )
                    :
                    skeleton.map((s,i)=>
                        <article className='col-md-3 col-sm-4' key={i}>
                            <ProductSkeleton />
                        </article>
                   )
                }
            </article>
            </section>
           
            
        </section>
    )
}

export default C3
